import { useEffect } from "react";

import { useHistory } from "react-router";

import { useGetOptionsApprovalStatus } from "~/v2/api/hooks";
import { FullScreenSpinner } from "~/v2/components/common";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { ApplicationStatus } from "./ApplicationStatus";

export const Status = () => {
  const history = useHistory();

  const { currentAccount, product } = useAccountContext({ liveOnly: true });

  const { data: status } = useGetOptionsApprovalStatus({
    accountID: currentAccount?.id,
    options: { enabled: !!currentAccount?.id && product === "live" },
  });

  const isLoading = !currentAccount;

  // If user has not applied move them to dashboard home
  useEffect(() => {
    if (status && status.OptionsRequestStatus === null) {
      history.replace(Path.ROUTE_DASHBOARD);
    }
  }, [status, history.replace]);

  if (!status || isLoading) {
    return <FullScreenSpinner />;
  }

  return <ApplicationStatus status={status} />;
};

export default Status;
